<template>
  <div>
    <span class="class-type">課程日期</span>
    <div
      class="programPicker"
      v-if="
        specificationDates &&
        specificationDates.length > 0 &&
        specificationDates[0].courseDate
      "
      v-cloak
    >
      <div
        class="type-option"
        v-if="specificationDate.specificationPrograms.length > 0"
        v-for="(specificationDate, key) in specificationDates"
        v-on:click="changeDateKey(key)"
        v-bind:class="{ clicked: key == dateKey }"
        v-text="specificationDate.courseDate"
      ></div>
    </div>
    <span class="class-type">方案選擇</span>
    <div
      class="SpecificationPicker"
      v-if="
        specificationDates[dateKey] &&
        specificationDates[dateKey].specificationPrograms &&
        specificationDates[dateKey].specificationPrograms.length >
          0 &&
        specificationDates[dateKey].specificationPrograms[0]
          .programName
      "
      v-cloak
    >
      <span
        class="type-option"
        v-for="(specificationProgram, key) in specificationDates[
          dateKey
        ].specificationPrograms"
        v-bind:class="{ clicked: key == programKey }"
        v-on:click="changeProgramKey(key)"
        v-text="specificationProgram.programName"
      >
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'specificationPrograms',
    'specificationDates',
    'programKey',
    'dateKey',
    'programName',
    'courseDate',
  ],
  data: () => ({
    currentDateKey: 0,
  }),
  mounted() {
    this.changeDateKeyByRequest();
    this.changeProgramKeyByRequest();
  },
  methods: {
    changeProgramKey: function (key) {
      this.$emit('change-program-key', {
        key: key,
      });
    },
    changeDateKey: function (key) {
      this.$emit('change-date-key', {
        key: key,
      });

      this.$emit('change-program-key', {
        key: 0,
      });
    },
    // 依網址自動選擇時間
    changeDateKeyByRequest() {
      for (let key in this.specificationDates) {
        if (
          this.courseDate === this.specificationDates[key].courseDate
        ) {
          this.changeDateKey(key);
          this.currentDateKey = key;
        }
      }
    },
    // 依網址自動選擇方案
    changeProgramKeyByRequest() {
      for (let key in this.specificationDates[this.currentDateKey]
        .specificationPrograms) {
        if (
          this.programName ===
          this.specificationDates[this.currentDateKey]
            .specificationPrograms[key].programName
        ) {
          this.changeProgramKey(key);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.programPicker {
  overflow: hidden;
  .programBtn {
    display: block;
    float: left;
    margin: 0 10px 0 0px;
    border: 1px solid #ccc;
    font-family: 'Futura T OT';
    cursor: pointer;
    transition: border 0.5s;
    padding: 5px;
    &:hover,
    &.clicked {
      border: 1px solid #000;
    }
    // .program{
    //     height: 100%;
    //     width: 100%;
    //     border:1px solid #000;
    // }
  }
}
</style>
